module.exports = __webpack_public_path__ + "img/Cypress 480x480 v2.2f3aa4b6.png";